import { render } from "./UpdatedInformationSection.vue?vue&type=template&id=f6a5bb00&scoped=true"
import script from "./UpdatedInformationSection.vue?vue&type=script&lang=js"
export * from "./UpdatedInformationSection.vue?vue&type=script&lang=js"

import "./UpdatedInformationSection.vue?vue&type=style&index=0&id=f6a5bb00&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a5bb00"]])

export default __exports__